'use client';

import { createContext, useContext } from 'react';

/**
 * A room opened from a page's stage can be closed back to that page. The stage offers the way
 * out through this context and the room's own controls show it; a room with no stage around it
 * (nothing to close to) gets null and shows no such control.
 */
export const RoomClose = createContext<(() => void) | null>(null);

export const useRoomClose = () => useContext(RoomClose);
